// Adaugă acest cod în useEffect-ul de render, după desenarea județelor:

// Draw uploaded data points
useEffect(() => {
  if (!svgRef.current || !pathGenerator || !mappingData || mappingData.length === 0) return
  
  const svg = d3.select(svgRef.current)
  
  // Remove existing data points
  svg.selectAll('.data-point').remove()
  
  // Add data points
  svg.selectAll('.data-point')
    .data(mappingData)
    .enter()
    .append('circle')
    .attr('class', 'data-point')
    .attr('cx', d => {
      if (d.coordinates && d.coordinates.length === 2) {
        return projection(d.coordinates)[0]
      }
      // Fallback to random position in Romania
      return projection([25 + Math.random() * 5 - 2.5, 45.5 + Math.random() * 2 - 1])[0]
    })
    .attr('cy', d => {
      if (d.coordinates && d.coordinates.length === 2) {
        return projection(d.coordinates)[1]
      }
      return projection([25 + Math.random() * 5 - 2.5, 45.5 + Math.random() * 2 - 1])[1]
    })
    .attr('r', 3)
    .style('fill', d => {
      const dataType = d.DATA_TYPE
      switch (dataType) {
        case 'ROUTES': return '#00f7ff'
        case 'INVOICES': return '#ff00ff'
        case 'ACTIVATIONS': return '#00ffd0'
        default: return '#9d00ff'
      }
    })
    .style('stroke', 'white')
    .style('stroke-width', 0.5)
    .style('opacity', 0.8)
    .style('filter', 'url(#point-glow)')
    .on('mouseover', function(event, d) {
      d3.select(this)
        .transition()
        .duration(200)
        .attr('r', 5)
        .style('opacity', 1)
      
      // Show tooltip
      if (tooltipRef.current) {
        tooltipRef.current.style.opacity = 1
        tooltipRef.current.style.left = `${event.pageX + 10}px`
        tooltipRef.current.style.top = `${event.pageY - 10}px`
        
        const content = Object.entries(d)
          .filter(([key]) => !['coordinates', 'mapped'].includes(key))
          .slice(0, 5)
          .map(([key, value]) => `<div><strong>${key}:</strong> ${value}</div>`)
          .join('')
        
        tooltipRef.current.innerHTML = `
          <div class="font-orbitron font-bold text-monster-cyan mb-2">Data Point</div>
          ${content}
          ${Object.keys(d).length > 5 ? '<div class="text-xs mt-2">...more data</div>' : ''}
        `
      }
    })
    .on('mouseout', function() {
      d3.select(this)
        .transition()
        .duration(200)
        .attr('r', 3)
        .style('opacity', 0.8)
      
      if (tooltipRef.current) {
        tooltipRef.current.style.opacity = 0
      }
    })
}, [mappingData, projection, pathGenerator])

// Adaugă acest gradient în secțiunea de defs:
defs.append('radialGradient')
  .attr('id', 'point-glow')
  .selectAll('stop')
  .data([
    { offset: '0%', color: 'white', opacity: 1 },
    { offset: '50%', color: 'currentColor', opacity: 0.8 },
    { offset: '100%', color: 'transparent', opacity: 0 }
  ])
  .enter()
  .append('stop')
  .attr('offset', d => d.offset)
  .attr('stop-color', d => d.color)
  .attr('stop-opacity', d => d.opacity)

  // La sfârșitul fișierului, înainte de ultima acoladă, adaugă:

export default Map2D